<template>
  <div class="position-relative h-100 w-100">
    <div class="map-header position-absolute text-light">
      <h2 class="h3 m-0"><span>Day 08 - </span>Blue</h2>
    </div>
    <div ref="map-root" class="basemap"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/src/css/mapbox-gl.css";

export default {
  data() {
    return {
      accessToken:
        "pk.eyJ1Ijoia21hcnNoYWxsIiwiYSI6ImNrdXdudGlpODI2ejkydXF2bXcyM3poaWQifQ.hyBCr6uwWlDGMGyVmuKCIw",
      map: null,
      center: [-40, 30],
    };
  },
  methods: {
    initMap() {
      mapboxgl.accessToken = this.accessToken;

      this.map = new mapboxgl.Map({
        container: this.$refs["map-root"],
        style: "mapbox://styles/mapbox/dark-v10",
        center: this.center,
        zoom: 3,
        minZoom: 3,
        maxZoom: 5,
      });

      this.map.on("load", () => {
        this.map.addSource("10m-bathymetry-81bsvj", {
          type: "vector",
          url: "mapbox://mapbox.9tm8dx88",
        });
        this.map.addLayer(
          {
            id: "10m-bathymetry-81bsvj",
            type: "fill",
            source: "10m-bathymetry-81bsvj",
            "source-layer": "10m-bathymetry-81bsvj",
            layout: {},
            paint: {
              "fill-outline-color": "hsla(337, 82%, 62%, 0)",
              // cubic bezier is a four point curve for smooth and precise styling
              // adjust the points to change the rate and intensity of interpolation
              "fill-color": [
                "interpolate",
                ["cubic-bezier", 0, 0.5, 1, 0.5],
                ["get", "DEPTH"],
                200,
                "#78bced",
                9000,
                "#15659f",
              ],
            },
          },
          "land-structure-polygon"
        );
      });

      const nav = new mapboxgl.NavigationControl();
      this.map.addControl(nav, "top-right");
      this.map.scrollZoom.disable();
    },
  },
  mounted() {
    this.initMap();
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/map-shared.scss";
</style>